export default {
  key: 'notfound',
  name: 'Not Found',
  value: true,
  hidden: true,
  options: []
}
